export const FETCH_YARD_DOCUMENTS = "FETCH_YARD_DOCUMENTS";
export const FETCH_YARD_DOCUMENTS_SUCCESS = "FETCH_YARD_DOCUMENTS_SUCCESS";
export const FETCH_YARD_DOCUMENTS_FAILURE = "FETCH_YARD_DOCUMENTS_FAILURE";
export const SAVE_LOCALES = "SAVE_LOCALES";
export const SAVE_LOCALES_SUCCESS = "SAVE_LOCALES_SUCCESS";
export const SAVE_LOCALES_FAILURE = "SAVE_LOCALES_FAILURE";
export const CLEAR_ERROR_SAVING_LOCALES = "CLEAR_ERROR_SAVING_LOCALES";
